const FAMILY_DEFINITIONS = Object.freeze([
  {
    id: 'heritage-stilt', label: 'Heritage Stilt', floors: 1, baseElevation: 0.9,
    roofStyle: 'layered-hip', wall: 'wood-teak', upperWall: 'wood-teak', roof: 'roof-brown', accent: 'wood-dark',
    glazing: 'classic', floorScale: [0.82, 0.82], veranda: true, stilts: true, entrySteps: true
  },
  {
    id: 'heritage-pavilion', label: 'Heritage Pavilion', floors: 1, baseElevation: 0.38,
    roofStyle: 'layered-hip', wall: 'wood-warm', upperWall: 'wood-warm', roof: 'roof-terracotta', accent: 'wood-dark',
    glazing: 'classic', floorScale: [0.88, 0.86], veranda: true, entrySteps: true
  },
  {
    id: 'compact-twin-gable', label: 'Compact Twin Gable', floors: 1, baseElevation: 0,
    roofStyle: 'split-gable', wall: 'wall-warm', upperWall: 'wall-warm', roof: 'roof-slate', accent: 'wood-teak',
    glazing: 'balanced', floorScale: [0.93, 0.9], facadeFrame: true, carport: false
  },
  {
    id: 'subsidized-modern', label: 'Modern Starter Home', floors: 1, baseElevation: 0,
    roofStyle: 'split-gable', wall: 'wall-warm', upperWall: 'wall-warm', roof: 'roof-charcoal', accent: 'wood-warm',
    glazing: 'balanced', floorScale: [0.9, 0.88], facadeFrame: true, carport: true
  },
  {
    id: 'tropical-bungalow', label: 'Tropical Hip Bungalow', floors: 1, baseElevation: 0.08,
    roofStyle: 'hip', wall: 'facade-cream', upperWall: 'facade-cream', roof: 'roof-charcoal', accent: 'wood-teak',
    glazing: 'wide', floorScale: [0.9, 0.88], veranda: true, carport: true, planter: true
  },
  {
    id: 'modern-courtyard', label: 'Modern Courtyard', floors: 2, baseElevation: 0,
    roofStyle: 'flat', wall: 'concrete-light', upperWall: 'wall-warm', roof: 'roof-charcoal', accent: 'wood-teak',
    glazing: 'wide', floorScale: [0.9, 0.86], upperScale: [0.84, 0.8], balcony: true, pool: true, planter: true
  },
  {
    id: 'modern-cantilever', label: 'Modern Cantilever', floors: 2, baseElevation: 0,
    roofStyle: 'flat', wall: 'concrete-warm', upperWall: 'concrete-light', roof: 'roof-charcoal', accent: 'wood-dark',
    glazing: 'wide', floorScale: [0.88, 0.86], upperScale: [0.88, 0.78], balcony: true, carport: true, slatScreen: true
  },
  {
    id: 'urban-wood-accent', label: 'Urban Wood Accent', floors: 2, baseElevation: 0,
    roofStyle: 'flat', wall: 'wall-warm', upperWall: 'concrete-light', roof: 'roof-charcoal', accent: 'wood-teak',
    glazing: 'wide', floorScale: [0.9, 0.84], upperScale: [0.82, 0.82], balcony: true, slatScreen: true, planter: true
  },
  {
    id: 'tropical-two-storey', label: 'Tropical Two Storey', floors: 2, baseElevation: 0.06,
    roofStyle: 'hip', wall: 'facade-cream', upperWall: 'wall-warm', roof: 'roof-slate', accent: 'wood-warm',
    glazing: 'wide', floorScale: [0.91, 0.88], upperScale: [0.82, 0.8], balcony: true, veranda: true, planter: true
  },
  {
    id: 'compact-split-mass', label: 'Compact Split Mass', floors: 2, baseElevation: 0,
    roofStyle: 'flat', wall: 'wall-warm', upperWall: 'wall-charcoal', roof: 'roof-charcoal', accent: 'wood-teak',
    glazing: 'vertical', floorScale: [0.84, 0.9], upperScale: [0.78, 0.84], balcony: true, carport: true, slatScreen: true
  }
]);

const WALL_PALETTES = Object.freeze([
  ['wall-warm', 'concrete-light'],
  ['facade-cream', 'wall-warm'],
  ['concrete-light', 'concrete-warm'],
  ['wall-warm', 'wall-charcoal'],
  ['concrete-warm', 'facade-cream']
]);

const WOOD_PALETTES = Object.freeze(['wood-teak', 'wood-warm', 'wood-dark', 'wood-teak', 'wood-warm']);

export function getHouseDesignProfile(index, seed) {
  const family = FAMILY_DEFINITIONS[index % FAMILY_DEFINITIONS.length];
  const variation = Math.floor(index / FAMILY_DEFINITIONS.length) % 5;
  const mirror = Boolean((seed >>> 2) % 2);
  const modern = !family.id.startsWith('heritage');
  const walls = modern ? WALL_PALETTES[variation] : [family.wall, family.upperWall];
  const offsetStep = ((variation % 3) - 1) * 0.42;
  const upperOffset = family.floors > 1
    ? [mirror ? -offsetStep : offsetStep, variation % 2 ? -0.28 : 0.18]
    : [0, 0];
  const roofStyle = variation === 4 && ['flat', 'hip'].includes(family.roofStyle)
    ? (family.roofStyle === 'flat' ? 'shed' : family.roofStyle)
    : family.roofStyle;
  const carport = Boolean(family.carport || (modern && variation === 4));
  const roofHeight = roofStyle === 'layered-hip' ? 1.9
    : roofStyle === 'hip' ? 1.55
      : roofStyle === 'split-gable' ? 1.4
        : roofStyle === 'shed' ? 0.85 : 0.3;
  const eave = roofStyle === 'layered-hip' ? 1.15 : roofStyle === 'hip' ? 0.9 : roofStyle === 'split-gable' ? 0.62 : 0.28;
  const profile = {
    ...family,
    profileId: `${family.id}-${variation + 1}`,
    variation,
    mirror,
    roofStyle,
    roofHeight: roofHeight + variation * 0.04,
    eave,
    wall: family.id.startsWith('heritage') ? family.wall : walls[0],
    upperWall: family.id.startsWith('heritage') ? family.upperWall : walls[1],
    accent: family.id.startsWith('heritage') ? family.accent : WOOD_PALETTES[variation],
    roof: family.id.startsWith('heritage') && variation % 2 ? 'roof-terracotta' : family.roof,
    upperOffset,
    landscapeDensity: 2 + variation,
    fence: modern && variation >= 2,
    pergola: modern && variation === 3,
    pool: Boolean(family.pool && variation !== 1),
    carport,
    vehicle: carport && (family.id === 'subsidized-modern' || variation === 4),
    balcony: Boolean(family.balcony && variation !== 0 ? true : family.balcony),
    plinth: modern,
    siteSurface: family.id.startsWith('heritage') ? 'garden' : variation % 2 ? 'mixed' : 'paved',
    roofTiles: !['flat', 'shed'].includes(roofStyle),
    deepFrames: modern && ['wide', 'vertical'].includes(family.glazing),
    facadePattern: variation,
    referenceFamilyIndex: index % FAMILY_DEFINITIONS.length
  };
  profile.floorScale = Object.freeze([...(family.floorScale ?? [0.9, 0.88])]);
  profile.upperScale = Object.freeze([...(family.upperScale ?? [0.84, 0.82])]);
  profile.upperOffset = Object.freeze([...upperOffset]);
  return Object.freeze(profile);
}

export const HOUSE_PROFILE_FAMILIES = FAMILY_DEFINITIONS;
